/** API client for the per-feeder data-quality rollup (spec §7 item 7). The
 *  no-boundary report is read from the rollup's `no_boundary` block, so no
 *  standalone endpoint client is needed. Auth header is attached automatically
 *  by the shared `get` helper. */

import { get } from './client.ts'
import type { DataQualityRollup } from '../types/dataQuality.ts'

export function getDataQuality(feederId: number): Promise<DataQualityRollup> {
  return get<DataQualityRollup>(`/engineering/data-quality/feeders/${feederId}`)
}
